/** @file Writes the vertex selection of one mesh (replace, add or toggle; other meshes' entries kept). */
import type { Id } from '@pose2d/format/types';
import { selectionStore } from '../../stores/selectionStore';
import type { SelectMode } from '../../stores/updateSelection';
import { vertexSelection } from './vertexSelection';

/** Same modes as the bone/slot selection (E1 selectModeOf: Ctrl toggles, Shift adds, plain replaces). */
export function selectVertices(attachment: Id, indices: readonly number[], mode: SelectMode): void {
  const sel = selectionStore.getState();
  selectionStore.setState({ vertices: mode === 'replace' ? vertexSelection.replace(sel, attachment, indices) : vertexSelection.add(sel, attachment, indices, mode === 'toggle') });
}
